import { Link } from 'react-router-dom';
import { Compass, Search, Home } from 'lucide-react';

export function NotFoundPage() {
  return (
    <div className="max-w-7xl mx-auto px-4 py-16 sm:py-24 text-center">
      <Compass className="mx-auto h-12 w-12 text-slate-300" />
      <h1 className="mt-4 text-2xl font-semibold text-navy-900">Page Not Found</h1>
      <p className="mt-2 text-sm text-slate-500">
        The page you&apos;re looking for doesn&apos;t exist or has been moved.
      </p>
      <div className="mt-6 flex items-center justify-center gap-4">
        <Link
          to="/"
          className="inline-flex items-center gap-1.5 rounded-md bg-brand-blue px-4 py-2 text-sm font-medium !text-navy-900 hover:bg-blue-700 hover:!text-white transition-colors"
        >
          <Home className="h-4 w-4" />
          Go Home
        </Link>
        <Link
          to="/search"
          className="inline-flex items-center gap-1.5 rounded-md border border-slate-300 px-4 py-2 text-sm font-medium text-slate-700 hover:bg-slate-50 transition-colors"
        >
          <Search className="h-4 w-4" />
          Search
        </Link>
      </div>
    </div>
  );
}
